import sort from "../assets/sort.svg"
import {useSelector, useDispatch} from 'react-redux';

import {
    fillOrder
} from "../store/interactions";

import{
    orderBookSelector,
} from "../store/selectors";



const Orderbook = ()=> {

    const symbols = useSelector(state => state.tokens.symbols);
    const orderBook = useSelector(orderBookSelector);
    const exchange = useSelector(state => state.exchange.contract);
    const provider = useSelector(state => state.provider.connection);

    const exchangeBalances = useSelector(state => state.exchange.balances);

    const dispatch = useDispatch();

    const fillOrderHandler = (order)=>{
        if(dispatch && provider && exchange && order) fillOrder(dispatch,provider,exchange,order);
        
    }

    
    
    return(
        <div className="component exchange__orderbook">
            <div className="component__header flex-between">
            <a href="https://open-dex.gitbook.io/docs-willow/quick-start#id-4.-order-book-must-have-order" target='_blank' class="hover:text-sky-500 transition-colors duration-300 ease-in-out  ">
                <h2 title="How to">Order Book &nbsp;<span>(your can click)</span></h2>
            </a>
            </div>

        <div className="">

            <div className="flex ">

            {
                        orderBook && orderBook.buyOrders.length ?(
                            <table className="exchange__orderbook--buy">
                                {/* <caption className="component__header__lock">Buying</caption> */}
                                <caption className="">Buying
                                <small className="ml-2">{symbols[0]} total: {exchangeBalances && Number(exchangeBalances[0]).toFixed(3)}</small>
                                </caption>
                                <thead className="component__header__lock">
                                {/* <br></br> */}
                                    <tr>
                                            <th>{symbols && symbols[0]} <img src={sort} alt="sort" /> </th>
                                            {/* <th>{symbols && symbols[0]}/{symbols && symbols[1]} <img src={sort} alt="sort" /> </th> */}
                                            <th>* Price <img src={sort} alt="sort" /> </th>
                                            <th>= {symbols && symbols[1]} <img src={sort} alt="sort" /> </th>
                                    </tr>
                                </thead>
                                <tbody title="Click to Buy">
                                    {
                                        orderBook && orderBook.buyOrders.map((order,index)=>{
                                            return (
                                                <tr key={index} onClick={()=> fillOrderHandler(order)} >
                                                    <td>{order.token0amount} </td>
                                                    <td style={{color: `${order.orderTypeClass}`}}>{order.tokenPrice} </td>
                                                    {/* <td>{order.token1amount}</td> */}
                                                    {/* <td>{order.token1amount < 1 && !Number.isInteger(order.token1amount) ? '~' : order.token1amount}</td> */}
                                                    <td>{(order.token1amount < 1 && order.token1amount % 1 !== 0) ? '~ total' : (order.token1amount === 0 ? 0 : order.token1amount)}</td>
                                                </tr>
                                            )
                                        })
                                    
                                    }
                                </tbody>
                            </table>
                        ):(
                            <p className="flex-center  animate-pulse" >NO BUY ORDERS YET!!</p>
                        )
                    }

                
                <div className="divider"></div>
                {
                    orderBook && orderBook.sellOrders.length?(
                        <table className="exchange__orderbook--sell">
                        {/* <caption className="component__header__lock">Selling</caption> */}
                        <caption className="">Selling
                        <small className="ml-2">{symbols[1]} total: {exchangeBalances && Number(exchangeBalances[1]).toFixed(3)}</small>
                        </caption>
                        <thead className="component__header__lock">
                        {/* <br></br> */}
                            <tr>
                                <th>{symbols && symbols[0]} <img src={sort} alt="sort" /> </th>
                                {/* <th>{symbols && symbols[0]}/{symbols && symbols[1]} <img src={sort} alt="sort" /> </th> */}
                                <th>* Price<img src={sort} alt="sort" /> </th>
                                <th>= {symbols && symbols[1]} <img src={sort} alt="sort" /> </th>
                            </tr>
                        </thead>
                        <tbody title="Click to Sell">
                            {
                                orderBook && orderBook.sellOrders.map((order,index)=>{
                                    return(
                                        <tr key={index} onClick={()=> fillOrderHandler(order)} >
                                            <td>{order.token0amount} </td>
                                            <td style={{color: `${order.orderTypeClass}`}}>{order.tokenPrice} </td>
                                            {/* <td>{order.token1amount}</td> */}
                                            {/* <td>{order.token1amount < 1 && !Number.isInteger(order.token1amount) ? '~' : order.token1amount}</td> */}
                                            <td>{(order.token1amount < 1 && order.token1amount % 1 !== 0) ? '~ total' : (order.token1amount === 0 ? 0 : order.token1amount)}</td>
                                        </tr>
                                    )
                                })
                            }
                            
                        </tbody>
                    </table>

                    ):(
                        <p className="flex-center animate-pulse">NO SELL ORDERS YET!!</p>
                    )
                }

                
        </div>


            </div>
        </div>
    );
}


export default Orderbook;